import { IRootState } from '../../../../store'
import { IAssessmentsAirwayState } from '../store/airway.types'

export const getInitialAssessmentAirway = (state: IRootState): IAssessmentsAirwayState => state.initialAssessmentAirway
